import { render, staticRenderFns } from "./HubHolidays.vue?vue&type=template&id=7944695f&"
import script from "./HubHolidays.vue?vue&type=script&lang=js&"
export * from "./HubHolidays.vue?vue&type=script&lang=js&"
import style0 from "./HubHolidays.vue?vue&type=style&index=0&id=7944695f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports